import { createSvgIcon } from '@mui/material';

const OcodeLogoIcon = createSvgIcon(
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          d="M25.057 1.145c-8.526-2.277-17.848 1.321-22.47 9.33a5.298 5.298 0 0 0 1.943 7.243 5.298 5.298 0 0 0 7.243-1.943C16.785 7.093 22.5.862 25.057 1.145Z"
          fill="url(#c)"
        />
        <path
          d="M37.232 10.484c-2.456-4.411-7.163-8.069-12.192-9.339-1.236-.122-3.205 1.262-5.474 3.705 5.855-1.093 12.535.834 17.662 5.634"
          fill="url(#d)"
        />
        <path
          d="M15.18 11.724c6.105-5.135 15.282-5 22.051-1.24-5.126-4.801-11.806-6.731-17.66-5.635-2.435 2.616-5.208 6.443-7.798 10.93a6.953 6.953 0 0 1 0 .005 15.218 15.218 0 0 1 3.407-4.052v-.008Z"
          fill="url(#e)"
        />
        <path
          d="M.559 25.61c2.29 8.525 10.066 14.799 19.316 14.799a5.304 5.304 0 0 0 0-10.609C9.846 29.8 1.592 27.963.559 25.61Z"
          fill="url(#f)"
        />
        <path
          d="M2.556 10.395c-2.59 4.33-3.403 10.24-1.994 15.227.513 1.134 2.697 2.146 5.944 2.891C2.633 23.988.965 17.24 2.556 10.4"
          fill="url(#g)"
        />
        <path
          d="M14.659 28.878C7.158 26.156 2.687 18.142 2.556 10.399c-1.596 6.841.076 13.59 3.95 18.114C9.99 29.31 14.689 29.8 19.87 29.8c-1.778 0-3.552-.317-5.211-.927v.005Z"
          fill="url(#h)"
        />
        <path
          d="M33.993 34.597c6.235-6.245 7.78-16.12 3.158-24.126a5.303 5.303 0 0 0-9.186 5.3c5.016 8.687 7.552 16.751 6.028 18.821v.005Z"
          fill="url(#i)"
        />
        <path
          d="M19.816 40.472c5.046.08 10.57-2.167 14.186-5.888.728-1.008.512-3.408-.47-6.592-1.981 5.618-6.989 10.44-13.711 12.48"
          fill="url(#j)"
        />
        <path
          d="M29.773 20.75c1.392 7.856-3.31 15.73-9.953 19.718 6.723-2.04 11.73-6.862 13.712-12.48-1.05-3.416-2.976-7.73-5.567-12.217a15.191 15.191 0 0 1 1.803 4.978h.005Z"
          fill="url(#k)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="c"
        x1="1.871"
        y1="9.451"
        x2="25.057"
        y2="9.451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".7" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="1.871"
        y1="5.811"
        x2="37.232"
        y2="5.811"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".3" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="8.589"
        y1="11.597"
        x2="34.408"
        y2="7.575"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".7" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="11.567"
        y1="46.026"
        x2="-.026"
        y2="25.947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".7" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="12.564"
        y1="47.754"
        x2="-6.113"
        y2="15.404"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".3" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="22.198"
        y1="42.191"
        x2="1.45"
        y2="14.297"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".7" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="46.17"
        y1="14.852"
        x2="34.577"
        y2="34.931"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".7" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="41.548"
        y1="12.183"
        x2="23.867"
        y2="42.806"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".3" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="33.177"
        y1="15.108"
        x2="23.75"
        y2="39.478"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity=".7" />
        <stop offset="1" stopColor="currentColor" stopOpacity=".5" />
      </linearGradient>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h40v40H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="currentColor" transform="translate(-.123 .472)" d="M0 0h148.257v40H0z" />
      </clipPath>
    </defs>
  </svg>,
  'OcodeLogoIcon',
);

export default OcodeLogoIcon;
